export default __webpack_public_path__ + "proximanova-semibold-webfont.woff2";